// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"284":"ba1712fc","893":"7bf94aed"}[chunkId] || chunkId) + "." + {"157":"02cff18b858bd4f9","284":"22db8dc83496e7a7","567":"8d27e78fbeceaa75","893":"a1778d43026bc957"}[chunkId] + ".js";
};